import { format, parseISO } from 'date-fns'
import ja from 'date-fns/locale/ja'

const getDateObject = (target: string | number | Date) => {
  if (typeof target === 'string') {
    return parseISO(target)
  }

  if (typeof target === 'number') {
    return new Date(target)
  }

  return target
}

const convertToJST = (target: string | number | Date) => {
  /**
   * The purpose of this method is to generate a JST-converted Date object,
   * but because it uses the Date constructor, it is converted to the browser's time zone.
   * Then, the time is added to offset the browser's timezone, and plus the time offset to be JST.
   */
  const targetDate = getDateObject(target)
  const originalUTC = new Date(targetDate)
  const localTime =
    originalUTC.getTime() + new Date().getTimezoneOffset() * 60 * 1000
  const jstTime = localTime + 9 * 3600 * 1000
  return new Date(jstTime)
}

/**
 * Converts a Date to a dateFormat
 *
 * [Docs:format](https://date-fns.org/v2.22.1/docs/format)
 */
export const formatDate = (
  date: string | number | Date,
  { dateFormat }: { dateFormat: string }
): string => {
  const targetDate = convertToJST(date)

  return format(targetDate, dateFormat, { locale: ja })
}
